/* eslint-disable import/prefer-default-export */
import loginService from './loginService';
import userService from './userService';
import vipService from './vipService';

/**
 * 初始化用户状态
 */
export const initUserState = async (): Promise<void> => {
  await loginService.init();
  await Promise.allSettled([userService.init(), vipService.init()]);
};

// 导出响应式对象
export { loginService, userService, vipService };
